import React from "react";

const UnlcockedIcon = ({ width = 21, height = 21, fill = "#FFB531" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 9 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="UnlockedIcon"
  >
    <path
      d="M1.50001 4.30291V3.69262C1.50001 2.03578 2.84314 0.692627 4.50001 0.692627C6.15687 0.692627 7.5 2.03578 7.5 3.69262V4.30291C8.27999 4.64333 8.78459 5.41303 8.78571 6.26405V8.83548C8.78431 10.0184 7.82575 10.9769 6.64287 10.9783H2.35716C1.17429 10.9769 0.215726 10.0184 0.214299 8.83548V6.26405C0.215405 5.41303 0.720027 4.64333 1.50001 4.30291ZM4.07144 7.97835C4.07144 8.21504 4.26331 8.40691 4.50001 8.40691C4.7367 8.21504 4.92857 8.21504 4.92857 7.97835V7.1212C4.92857 6.88451 4.7367 6.69263 4.50001 6.69263C4.26331 6.69263 4.07144 6.88451 4.07144 7.1212V7.97835ZM2.35714 4.12121H6.64287V3.69264C6.64287 2.50918 5.68349 1.54978 4.50001 1.54978C3.31653 1.54978 2.35714 2.50916 2.35714 3.69264V4.12121Z"
      fill={fill}
    />
  </svg>
);

export default UnlcockedIcon;
